"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SURVEY_CURRENT_QUESTION_SET = exports.CONVERSATION_SET = exports.CONVERSATION_REMOVE_LAST = exports.CONVERSATION_QUEUE_SET = exports.CONVERSATION_QUEUE_CLEAR = exports.CONVERSATION_PROCESSING_SET = exports.CONVERSATION_CLEAR = exports.APP_VARIABLES_SET = exports.APP_TYPING_SET = exports.APP_SETTINGS_SET = exports.APP_SCROLLED_SET = exports.APP_PRODUCT_SET = exports.APP_INPUT_VALIDATION_SET = exports.APP_ERROR_SET = exports.APP_ENV_SET = exports.APP_DEBUG_SET = exports.APP_CONVERSATION_ID_SET = exports.APP_CONTEXT_SET = exports.APP_BOT_PROJECT_ID_SET = exports.APP_BLOCKED_SET = void 0;
var APP_BLOCKED_SET = 'APP_BLOCKED_SET';
exports.APP_BLOCKED_SET = APP_BLOCKED_SET;
var APP_BOT_PROJECT_ID_SET = 'APP_BOT_PROJECT_ID_SET';
exports.APP_BOT_PROJECT_ID_SET = APP_BOT_PROJECT_ID_SET;
var APP_CONTEXT_SET = 'APP_CONTEXT_SET';
exports.APP_CONTEXT_SET = APP_CONTEXT_SET;
var APP_CONVERSATION_ID_SET = 'APP_CONVERSATION_ID_SET';
exports.APP_CONVERSATION_ID_SET = APP_CONVERSATION_ID_SET;
var APP_DEBUG_SET = 'APP_DEBUG_SET';
exports.APP_DEBUG_SET = APP_DEBUG_SET;
var APP_ENV_SET = 'APP_ENV_SET';
exports.APP_ENV_SET = APP_ENV_SET;
var APP_ERROR_SET = 'APP_ERROR_SET';
exports.APP_ERROR_SET = APP_ERROR_SET;
var APP_INPUT_VALIDATION_SET = 'APP_INPUT_VALIDATION_SET';
exports.APP_INPUT_VALIDATION_SET = APP_INPUT_VALIDATION_SET;
var APP_PRODUCT_SET = 'APP_PRODUCT_SET';
exports.APP_PRODUCT_SET = APP_PRODUCT_SET;
var APP_SCROLLED_SET = 'APP_SCROLLED_SET';
exports.APP_SCROLLED_SET = APP_SCROLLED_SET;
var APP_SETTINGS_SET = 'APP_SETTINGS_SET';
exports.APP_SETTINGS_SET = APP_SETTINGS_SET;
var APP_TYPING_SET = 'APP_TYPING_SET';
exports.APP_TYPING_SET = APP_TYPING_SET;
var APP_VARIABLES_SET = 'APP_VARIABLES_SET';
exports.APP_VARIABLES_SET = APP_VARIABLES_SET;
var CONVERSATION_CLEAR = 'CONVERSATION_CLEAR';
exports.CONVERSATION_CLEAR = CONVERSATION_CLEAR;
var CONVERSATION_PROCESSING_SET = 'CONVERSATION_PROCESSING_SET';
exports.CONVERSATION_PROCESSING_SET = CONVERSATION_PROCESSING_SET;
var CONVERSATION_QUEUE_CLEAR = 'CONVERSATION_QUEUE_CLEAR';
exports.CONVERSATION_QUEUE_CLEAR = CONVERSATION_QUEUE_CLEAR;
var CONVERSATION_QUEUE_SET = 'CONVERSATION_QUEUE_SET';
exports.CONVERSATION_QUEUE_SET = CONVERSATION_QUEUE_SET;
var CONVERSATION_REMOVE_LAST = 'CONVERSATION_REMOVE_LAST';
exports.CONVERSATION_REMOVE_LAST = CONVERSATION_REMOVE_LAST;
var CONVERSATION_SET = 'CONVERSATION_SET';
exports.CONVERSATION_SET = CONVERSATION_SET;
var SURVEY_CURRENT_QUESTION_SET = 'SURVEY_CURRENT_QUESTION_SET';
exports.SURVEY_CURRENT_QUESTION_SET = SURVEY_CURRENT_QUESTION_SET;